//IE11 swiper js 'startsWith' Polyfill
if (!String.prototype.startsWith) {
	String.prototype.startsWith = function (searchString, position) {
		position = position || 0
		return this.substr(position, searchString.length) === searchString
	}
}

const focusableEl = ['a', 'button']

function doAllSlidesNotFocusable() {
	this.slides.forEach(slide => {
		slide.ariaHidden = true
		focusableEl.forEach(selector => {
			slide.querySelectorAll(`${selector}:not(.not-focusable)`).forEach(el => {
				el.tabIndex = -1
				el.ariaHidden = true
			})
		})
	})
}

function doActiveSlideFocusable() {
	let activeIndex = this.activeIndex
	this.slides.forEach((slide, index) => {
		if (index === activeIndex) {
			slide.ariaHidden = false
			focusableEl.forEach(selector => {
				slide.querySelectorAll(`${selector}:not(.not-focusable)`).forEach(el => {
					el.tabIndex = 0
					el.ariaHidden = false
				})
			})
		}
	})
}

function startFloatSwiper(element) {
	var floatSwiper = new Swiper(`${element} .swiper-container`, {
		preventClicks: true,
		preventClicksPropagation: true,
		slidesPerView: 'auto',
		initialSlide: 0,
		spaceBetween: 0,
		parallax: true,
		speed: 1000,
		allowTouchMove: true,
		loop: true,
		lazyPreloadPrevNext: 3,
		a11y: {
			enabled: true,
			slideLabelMessage: '',
			slideRole: ''
		},
		navigation: {
			prevEl: `${element} .swiper-button-prev`,
			nextEl: `${element} .swiper-button-next`
		},
		scrollbar: {
			el: `${element} .swiper-scrollbar`,
			draggable: false,
		},
		pagination: {
			el: `${element} .swiper-pagination-fraction`,
			type: 'fraction'
		},

		breakpoints: {
			1490: {
				centeredSlides: true,
			}
		},
		on: {
			init: function () {
				doAllSlidesNotFocusable.call(this)
				doActiveSlideFocusable.call(this)
			},
			slideChangeTransitionStart: function () {
				doAllSlidesNotFocusable.call(this)
			},
			slideChangeTransitionEnd: function() {
				doActiveSlideFocusable.call(this)
			}
		}

	})
}

function startProdSlider(element) {
	var swiper = new Swiper(`${element} .swiper-container`, {
		loop: true,
		slidesPerView: 1,
		lazyPreloadPrevNext: 3,
		a11y: {
			enabled: true,
			slideRole: '',
			slideLabelMessage: ''
		},
		navigation: {
			prevEl: `${element} .swiper-button-prev`,
			nextEl: `${element} .swiper-button-next`,
		},
		on: {
			init: function () {
				doAllSlidesNotFocusable.call(this)
				doActiveSlideFocusable.call(this)
			},
			slideChangeTransitionStart: function () {
				doAllSlidesNotFocusable.call(this)
			},
			slideChangeTransitionEnd: function() {
				doActiveSlideFocusable.call(this)
			}
		}
	})
}

startFloatSwiper('#bedding-slider')
startFloatSwiper('#bath-slider')

startProdSlider('#linens-prodslider')
startProdSlider('#bathspa-prodslider')

// Fragrance Collection
var hpFragrances = new Swiper('.hp-fragrance .swiper-container', {
	preventClicks: true,
	preventClicksPropagation: true,
	slidesPerView: 1.5,
	spaceBetween: 10,
	lazyPreloadPrevNext: 3,
	loop: true,
	breakpoints: {
		769: {
			slidesPerView: 3,
			allowTouchMove: true,
			spaceBetween: 10,
		}
	},
	navigation: {
		prevEl: '.hp-fragrance .swiper-button-prev',
		nextEl: '.hp-fragrance .swiper-button-next'
	},
	scrollbar: {
		el: '.hp-fragrance .swiper-scrollbar',
		draggable: false,
	},
	pagination: {
		el: '.hp-fragrance .swiper-progressbar',
		type: 'fraction'
	},
	a11y: {
		enabled: true,
		slideRole: '',
		slideLabelMessage: ''
	},
	on: {
		init: function () {
			doAllSlidesNotFocusable.call(this)
			doActiveSlideFocusable.call(this)
		},
		slideChangeTransitionStart: function () {
			doAllSlidesNotFocusable.call(this)
		},
		slideChangeTransitionEnd: function() {
			doActiveSlideFocusable.call(this)
		}
	}
})

// Image
var swiper = new Swiper('.item-image .swiper-container', {
	slidesPerView: 1,
	spaceBetween: 0,
	watchOverflow: true,
	lazyPreloadPrevNext: 3,
	a11y: {
		enabled: true,
		slideRole: '',
		slideLabelMessage: ''
	},
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	}
})

// Tab
const swiperTab = new Swiper('.tab-navigation .swiper-container', {
	slidesPerView: 7,
	loop: true,
	allowTouchMove: false,
	lazyPreloadPrevNext: 3,
	a11y: {
		enabled: false,
		slideRole: '',
		slideLabelMessage: ''
	},
	navigation: {
		nextEl: '.hp-journey .swiper-button-next',
		prevEl: '.hp-journey .swiper-button-prev',
	},
})

const swiperTabContent = new Swiper('.tab-content .swiper-container', {
	slidesPerView: 1,
	loop: true,
	lazyPreloadPrevNext: 3,
	navigation: {
		nextEl: '.hp-journey .swiper-button-next',
		prevEl: '.hp-journey .swiper-button-prev',
	},
	on: {
		// Triggered on each slide change
		slideChange: function () {
			// Cache the journey container, tab links wrapper, and panels wrapper
			const $journey = $('.hp-journey')
			const $tabLinksWrap = $journey.find('#journey-tabs')
			const $panelsWrapper = $journey.find('#journey-panels')

			// Get the IDs of the currently active tab and panel
			const $currentActiveTab = $tabLinksWrap.find('.active').prop('id')
			const $currentActivePanel = $panelsWrapper.find('.swiper-slide-active').prop('id')

			// Find the first anchor within the currently active panel and set its tabindex to -1
			const currentAnchor = $(`#${$currentActivePanel} a:first-child`)
			currentAnchor.attr('tabindex', '-1')

			// Remove active classes from the currently active tab and set attributes accordingly
			$(`#${$currentActiveTab}`).removeClass('tab-active swiper-slide-active active').attr({
				'tabindex': '-1',
				'aria-selected': 'false',
				'aria-hidden': 'true'
			})
		},

		// Triggered at the end of the slide change transition
		slideChangeTransitionEnd: function () {
			// Cache the journey container and panels wrapper
			const $journey = $('.hp-journey')
			const $panelsWrapper = $journey.find('#journey-panels')

			// Get the ID of the currently active panel and derive the corresponding tab ID
			const $currentActivePanel = $panelsWrapper.find('.swiper-slide-active').prop('id')
			const $currentActiveTab = $currentActivePanel.replace('panel', 'tab')

			// Find the first anchor within the currently active panel and set its tabindex to 0
			const currentAnchor = $(`#${$currentActivePanel} a:first-child`)
			currentAnchor.attr('tabindex', '0')

			// Add active classes to the currently active tab and set attributes accordingly
			$(`#${$currentActiveTab}`).addClass('tab-active swiper-slide-active active').attr({
				'tabindex': '0',
				'aria-selected': 'true',
				'aria-hidden': 'false'
			})
		}
	}
})

const tabItems = document.querySelectorAll('.tab-navigation .swiper-slide')
tabItems.forEach((link, index) => {
	link.addEventListener('click', () => {
		tabItems.forEach(link => link.classList.remove('tab-active'))
		link.classList.add('tab-active')
		swiperTabContent.slideTo(index)
	})
})

